export enum FileExtension {
  PNG = 'png',
  PDF = 'pdf',
}
